<div class="graph-container">
  @if (loading$ | async) {
    <div class="loading-bar">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <div class="header">
    <span class="name">{{ data.name ?? ('DASHBOARD.TYPE_GRAPH' | translate) }}</span>
    <app-uplot-range-picker
      [disabled]="rangePickDisabled"
      [currentRange]="currentRange"
      (rangeHasChanged)="changeRange($event)"
    >
    </app-uplot-range-picker>
  </div>

  <div class="graph">
    @if (!noData) {
      <canvas baseChart [data]="config.data" [options]="config.options" [type]="config.type">
      </canvas>
    } @else {
      <p class="no-data">{{ 'INSPECT.NO_DATA' | translate }}</p>
    }
  </div>
</div>
